var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLogoAgentic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 26.6709C2.66602 1.77898 29.3359 1.77897 29.3359 26.6709",
    stroke: "#4660C8",
    strokeWidth: 2.66699
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26.6714C8 10.6694 24.002 10.6694 24.002 26.6714L8 26.6714Z",
    fill: "#4660C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogoAgentic);
export default __webpack_public_path__ + "static/media/small_logo_agentic.eb43d078bbcbfb2eaea887a130c69305.svg";
export { ForwardRef as ReactComponent };